import "ag-grid-enterprise";
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeCctvComponent } from './home-cctv/home-cctv.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CctvcampusComponent } from './cctvcampus/cctvcampus.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { VideoComponent } from './video/video.component';
import { MatDialogModule } from '@angular/material/dialog';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BuildingsComponent } from './buildings/buildings.component';
import { CampusComponent } from './campus/campus.component';
import { CampuscctvserviceService } from './service/campuscctvservice.service';
import { MatInput, MatInputModule } from '@angular/material/input';

import { MatCardModule } from '@angular/material/card';
import { CityComponent } from './city/city.component';
import { StateComponent } from './state/state.component';
import { DashboardComponent } from './dashboard/dashboard.component';
// import { ChartModule } from 'angular-highcharts';
import { SigninComponent } from './signin/signin.component';
import { InterceptorService } from './interceptor.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxUiLoaderModule, NgxUiLoaderHttpModule } from "ngx-ui-loader";
import { UserComponent } from './module/user/user.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { FilterPipe } from './filter.pipe';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TotaldvrComponent } from './totaldvr/totaldvr.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { MatDividerModule } from '@angular/material/divider';
// import { CounsellingComponent } from './modules/counselling/counselling/counselling.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DashboardCctvComponent } from './dashboard-cctv/dashboard-cctv.component';
import { DashboardCctvNotconnectedComponent } from './dashboard-cctv-notconnected/dashboard-cctv-notconnected.component';
import { DvrNvrstatusComponent } from './dvr-nvrstatus/dvr-nvrstatus.component';
import { DashboardCctvStreamingComponent } from './dashboard-cctv-streaming/dashboard-cctv-streaming.component';
import { DashboardCctvNotstreamingComponent } from './dashboard-cctv-notstreaming/dashboard-cctv-notstreaming.component';
import { DashboardCctvNovideoComponent } from './dashboard-cctv-novideo/dashboard-cctv-novideo.component';
import { DvrConnectedComponent } from './dvr-connected/dvr-connected.component';
import { DvrNotconnectedComponent } from './dvr-notconnected/dvr-notconnected.component';
import { AcademicFormModule } from './modules/academic-form/academic-form.module';
import { WifiModule } from './modules/wifi/wifi.module';
import { ReUsedcssComponent } from './re-usedcss/re-usedcss.component';
import { AttendanceModule } from './modules/attendance/attendance.module';
import { CourseMasterModule } from './modules/course-Master/course-master.module';
import { ViewalldailogComponent } from './viewalldailog/viewalldailog.component';
import { VideostreamingComponent } from './videostreaming/videostreaming.component';
import { MatMenuModule } from '@angular/material/menu';
import { BulkUploadDvrDetailsComponent } from './bulk-upload-dvr-details/bulk-upload-dvr-details.component';
// import { ExcelService } from './excel.service';
import { AddDvrComponent } from './add-dvr/add-dvr.component';
import { DvrdetailsdialogComponent } from './dvrdetailsdialog/dvrdetailsdialog.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CounsellingDashboardModule } from './modules/Student-Counselling-dashboard/counselling-dashboard.module';

import { AssestsModule } from './modules/assests tracting/assests.module';

import { DecimalPipe } from '@angular/common';
import { EmployeedeleteModule } from './modules/employee-login/employeedelete.module';
import { DeleteModule } from './modules/parent-login/delete.module';
import { TotaldvrDialogComponent } from './totaldvr-dialog/totaldvr-dialog.component';
import { CounsellingModule } from './modules/counselling/counselling.module';

// import { GridModule, ResizeService } from '@syncfusion/ej2-angular-grids';

import { ResizableColumnsDirective } from './totaldvr/resizable-columns.directive';
import { TableResizeComponent } from './table-resize/table-resize.component';
import { OnlyNumberDirective } from './dvrdetailsdialog/only-number.directive'
import { ParentAppModule } from './modules/parent-App/parent-app.module';
import { ReceiptCancellationModule } from './modules/ReceiptCancellation/receipt-cancellation.module';
import { SharedModule } from './shared/shared.module';  // Import SharedModule

import { ToastrModule } from 'ngx-toastr';
import { HighchartsChartModule } from 'highcharts-angular';
import { TotaldvreditDialogComponent } from './totaldvredit-dialog/totaldvredit-dialog.component';
import { IpemarkesModule } from './modules/IPEMARKES/ipemarkes.module';
import { AssetvehicleRoutingModule } from './modules/asset-vehicle-entry/assetvehicle-routing.module';
import { AssetvehicleModule } from './modules/asset-vehicle-entry/assetvehicle.module';
import { AssetqrapprovalModule } from './modules/Asset-QR-Approval/assetqrapproval.module';
import { AssetTransferApproveModule } from './modules/asset-transfer-approve/asset-transfer-approve.module';
import { PrintAssetsQRModule } from './modules/print-Asset-QR/print-assets-qr.module';
import { BulkAssetModule } from './modules/print-Bulk-assetQR-Details/bulk-asset.module';
import { AssetTransferEntryModule } from './modules/Asset-Transfer-Entry/asset-transfer-entry.module';
import { AssetVehicleApprovalModule } from './modules/asset-vehicle-approval/asset-vehicle-approval.module';
import { PrintVehicleQrModule } from './modules/print-assetvehicle-QR/print-vehicle-qr.module';
import { PrintBulkVehicleModule } from './modules/print-Bulk-assetVehicleQR-Details/print-bulk-vehicle.module';
import { UppercasePipe } from './uppercase.pipe';
// import { MargationModule } from './modules/margtion-entry-form/margation.module';
import { StudentMigrationModule } from './modules/student-migration-form/student-migration.module';
import { PushNotificationModule } from './modules/Sms  Push Notification/push-notification.module';
import { StudentVerificationModule } from './modules/Student  Verification/student-verification.module';
import { LogtrackingModule } from './modules/Log-Tracking/logtracking.module';
// import { FlatpickrModule } from 'angularx-flatpickr';
import { AgGridAngular, AgGridModule } from "ag-grid-angular";
import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, ExcelExportModule, LicenseManager } from "ag-grid-enterprise";
import { environment } from 'src/environments/environment';
import { GrievanceDashboardModule } from './modules/Grievance-Dashboard/grievance-dashboard.module';
import { ScoreRegistrationModule } from './modules/Score-Registration/score-registration.module';
import { StudentCounsellingReportModule } from './modules/student counselling Report/student-counselling-report.module';
import { GmDashboardModule } from './modules/Gm-Dashboard/gm-dashboard.module';
import { InputAlertComponent } from './modules/input-alert/input-alert.component';
import { MessDetailsModule } from './modules/mess-details/mess-details.module';
import { HygieneReportModule } from './modules/Hygiene Report/hygiene-report.module';
import { PayOnlineModule } from './modules/pay-online/pay-online.module';
import { OutingApprovalModule } from './modules/outing-approval/outing-approval.module';
import { OutingHeaderComponent } from './modules/outing-approval/outing-header/outing-header.component';
import { IosRegistrationFormModule } from './modules/ios-registration-form/ios-registration-form.module';
import { SurveillancesModule } from './modules/surveillance/surveillances.module';
import { EmployeeGrevienceModule } from './modules/employee-grevience/employee-grevience.module';
import { HrmsReportsModule } from './modules/hrms-reports/hrms-reports.module';
import { StudentCounsellingDetialsReportModule } from './modules/student counselling details/student-counselling-detials-report.module';
import { JeeMainsSession1EntryModule } from './modules/HallTicketEntry/jee-mains-session1-entry.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FacultyTrackingDashbaordModule } from "./modules/faculty-tracking-dashbaord/faculty-tracking-dashbaord.module";
import { JeeMainsHallTicketVerificationModule } from "./modules/jee-mains-hall-ticket-verification/jee-mains-hall-ticket-verification.module";
import { CollectSchoolDetailsComponent } from './modules/collect-school-details/collect-school-details.component';
import { BuildingImagesModule } from "./modules/building-Image/building-images.module";
import { HygieneStaftReportModule } from "./modules/Hygine-Staft-report/hygiene-staft-report.module";
import { StudentFeedbackModule } from "./modules/student -feedback/student-feedback.module";
import { HrModule } from "./hr/hr.module";
import { SelfAssessmentModule } from "./modules/Self-Assessment/self-assessment.module";
import { ScenarioAssessmentModule } from "./modules/Scenario-Assessment/scenario-assessment.module";
import { StudentWellBeingModule } from "./modules/student-well-being/student-well-being/student-well-being.module";
import { WarningAlertComponent } from './warning-alert/warning-alert.component';
import { AlertComponent } from './alert/alert.component';
import { StudentAttendanceModule } from "./modules/student_Attendances/student-attendance.module";
import { LayoutSidebarComponent } from './layout-sidebar/layout-sidebar.component';
// import { MainUserComponent } from './module/main-user/main-user.component';
import { MainHeaderComponent } from './main-header/main-header.component';
// import { LayoutSidebarComponent } from "./layout/layout-sidebar/layout-sidebar.component";
import { EmployeeModule } from "./hr/employee/employee.module";






ModuleRegistry.registerModules([AllEnterpriseModule, ExcelExportModule]);

LicenseManager.setLicenseKey(environment.ag_grid_key);







// export const MY_DATE_FORMATS = {
//   parse: {
//     dateInput: 'LL',
//   },
//   display: {
//     dateInput: 'DD MMMM YYYY',
//     monthYearLabel: 'MMMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY',
//   },
// };

// 12/12/2025

// export const MY_DATE_FORMATS = {
//   parse: {
//     dateInput: 'DD MMM YYYY',
//   },
//   display: {
//     dateInput: 'DD MMM YYYY',
//     monthYearLabel: 'MMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY',
//   },
// };

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeCctvComponent,
    CctvcampusComponent,
    VideoComponent,
    BuildingsComponent,
    CampusComponent,
    CityComponent,
    StateComponent,
    DashboardComponent,
    SigninComponent,
    UserComponent,
    FilterPipe,
    TotaldvrComponent,
    DashboardCctvComponent,
    DashboardCctvNotconnectedComponent,
    DvrNvrstatusComponent,
    DashboardCctvStreamingComponent,
    DashboardCctvNotstreamingComponent,
    DashboardCctvNovideoComponent,
    DvrConnectedComponent,
    DvrNotconnectedComponent,
    ReUsedcssComponent,
    ViewalldailogComponent,
    VideostreamingComponent,
    BulkUploadDvrDetailsComponent,
    AddDvrComponent,
    DvrdetailsdialogComponent,
    TotaldvrDialogComponent,
    ResizableColumnsDirective,
    TableResizeComponent,
    OnlyNumberDirective,
    TotaldvreditDialogComponent,
    UppercasePipe,
    InputAlertComponent,
    CollectSchoolDetailsComponent,
    WarningAlertComponent,
    AlertComponent,
    LayoutSidebarComponent
    // MainUserComponent,
    // MainHeaderComponent,
    // LayoutSidebarComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserAnimationsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatDialogModule,
    HttpClientModule,
    FormsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatInputModule,
    MatCardModule,
    MatProgressSpinnerModule,
    NgxUiLoaderModule,
    NgxUiLoaderHttpModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatSortModule,
    MatRadioModule,
    MatTableModule,
    MatPaginatorModule,
    DropDownsModule,
    InputsModule,
    LabelModule,
    MatDividerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    PayOnlineModule,
    MatButtonModule,
    MatSnackBarModule,
    AcademicFormModule,
    WifiModule,
    AttendanceModule,
    MatMenuModule,
    ScrollingModule,
    CourseMasterModule,
    CounsellingDashboardModule,
    AssestsModule,
    EmployeedeleteModule,
    DeleteModule,
    CounsellingModule,
    ParentAppModule,
    HighchartsChartModule,
    ReceiptCancellationModule,
    SharedModule,
    IpemarkesModule,
    AssetvehicleModule,
    AssetqrapprovalModule,
    PrintAssetsQRModule,
    BulkAssetModule,
    AssetTransferEntryModule,
    AssetTransferApproveModule,
    AssetVehicleApprovalModule,
    PrintVehicleQrModule,
    PrintBulkVehicleModule,
    StudentVerificationModule,
    // MargationModule,
    StudentMigrationModule,
    PushNotificationModule,
    AgGridModule,
    LogtrackingModule,
    GrievanceDashboardModule,
    ScoreRegistrationModule,
    StudentCounsellingReportModule,
    GmDashboardModule,
    MessDetailsModule,
    HygieneReportModule,
    OutingApprovalModule,
    IosRegistrationFormModule,
    EmployeeGrevienceModule,
    StudentCounsellingDetialsReportModule,
    SurveillancesModule,
    HrmsReportsModule,
    JeeMainsSession1EntryModule,
    FacultyTrackingDashbaordModule,
    BuildingImagesModule,
    HygieneStaftReportModule,
    StudentFeedbackModule,
    HrModule,
    JeeMainsHallTicketVerificationModule,
    SelfAssessmentModule,
    ScenarioAssessmentModule,
    StudentWellBeingModule,
    StudentAttendanceModule,
    EmployeeModule,
    // FlatpickrModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      // positionClass: 'toast-top-full-width',
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    MatAutocompleteModule
  ],

  providers: [CampuscctvserviceService, DecimalPipe, { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }, NgDialogAnimationService],
  bootstrap: [AppComponent]
})
export class AppModule { }
